<template>
  <div>
    <div
      style="min-height: 100vh"
      class="flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div
        class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-4/5 sm:m-0 m-4 xl:px-4"
      >
        <vx-card
          class="my-12"
          style="border-radius: 0.5rem !important; overflow: hidden"
        >
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <div style="position: relative" class="h-full min-h-screen">
                  <vx-card
                    class="w-3/4 bg-dark"
                    style="
                      overflow: hidden;
                      position: absolute;
                      left: 50%;
                      top: 50%;
                      transform: translate(-50%, -50%);
                      min-height: 400px;
                    "
                  >
                    <div id="logo-badge">
                      <div class="d-flex align-items-center h-full px-1">
                        <!-- <LogoRed class="w-full" /> -->
                        <img
                          v-if="!!form && !!form.logo"
                          :src="form.logo"
                          class="w-full"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      class="text-white"
                      style="position: relative; padding-left: 75px; top: -15px"
                    >
                      {{ form.name }}
                    </div>
                    <div id="card-bg" class="w-full h-full">
                      <h3 class="text-white m-6">Upcoming Events</h3>
                      <div class="m-6">
                        <vx-card class="" style="max-width: 300px">
                          <div>
                            <img
                              :src="event.poster"
                              style="
                                max-width: 100%;
                                width: auto;
                                height: auto;
                                max-height: 400px;
                                min-height: 100px;
                              "
                              alt=""
                            />
                          </div>
                          <h5 class="mt-3">
                            {{ event.name }}
                          </h5>
                          <div class="mt-5">
                            <div>
                              <i class="far fa-calendar-alt"></i>
                              {{ dateTextOnCard }}
                            </div>
                            <div>
                              <i class="fa fa-location"></i> {{ event.venue }}
                            </div>
                          </div>
                        </vx-card>
                      </div>
                    </div>
                  </vx-card>
                  <!-- <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" /> -->
                </div>
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div slot="no-body" class="">
                  <div class="p-4">
                    <LogoRed
                      class="w-32 mt-1 mb-1 mr-0 fill-current text-primary"
                    />
                    <h1>
                      <span> Create Event</span>
                      <span> 🚀 </span>
                    </h1>
                    <div style="font-size: 0.75rem; color: #aaa">
                      Get started by create Event
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Event Poster</div>
                      <div v-if="event.poster != null">
                        <img
                          :src="event.poster"
                          :width="imageWidth"
                          :height="imageHeight"
                        />
                      </div>
                      <div
                        v-if="!event.poster"
                        class="default-upload"
                        style="
                          width: 300px;
                          height: 158px;
                          background-color: #f5f5f5;
                          border-radius: 8px;
                          position: relative;
                        "
                      >
                        <vs-button
                          style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                          "
                          color="dark"
                          type="border"
                          @click="chooseImage()"
                        >
                          <span>Upload</span>
                        </vs-button>
                      </div>
                      <div
                        class="grid-button-upload"
                        style="
                          margin-top: 8px;
                          display: grid;
                          grid-template-columns: repeat(2, min-content);
                          grid-gap: 10px;
                        "
                      >
                        <!-- secondary / border  >> btn-->
                        <vs-button
                          v-if="event.poster"
                          color="dark"
                          type="border"
                          icon="autorenew"
                          style="display: flex"
                          @click="chooseImage()"
                        >
                          <span>Change</span>
                        </vs-button>
                        <input
                          style="
                            visibility: hidden;
                            position: flex;
                            left: -500%;
                          "
                          id="file-upload-img"
                          @change="onUploadImages()"
                          type="file"
                          ref="fileImage"
                        />
                        <vs-button
                          v-if="event.poster"
                          color="dark"
                          type="border"
                          icon="delete_forever"
                          style="display: flex"
                          @click="popupActivo = true"
                        >
                          Remove
                        </vs-button>
                        <vs-popup
                          classContent="popup-confirm"
                          title="Confirm Delete"
                          :active.sync="popupActivo"
                        >
                          <div>Are you sure you want to delete the image?</div>
                          <div class="wrap-button">
                            <vs-button
                              color="dark"
                              type="border"
                              style="font-size: 12px !important"
                              @click="popupActivo = false"
                            >
                              No
                            </vs-button>
                            <vs-button
                              color="primary"
                              style="font-size: 12px !important"
                              @click="removeposter()"
                            >
                              Yes
                            </vs-button>
                          </div>
                        </vs-popup>
                      </div>
                    </div>
                    <div>
                      <div style="font-size: 0.7rem">Event Name</div>
                      <div>
                        <vs-input
                          v-validate="'required'"
                          name="name"
                          class="w-full"
                          placeholder="Event Name"
                          v-model="event.name"
                          :maxLength="60"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('name')"
                        >
                          {{ splitError(errors.first("name"), " name") }}
                        </span>
                      </div>
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Event Date</div>
                      <div>
                        <el-date-picker
                          v-validate="'required'"
                          name="daterange"
                          style="width: 100%"
                          value-format="yyyy-MM-dd HH:mm"
                          format="dd-MM-yyyy HH:mm"
                          v-model="event.daterange"
                          type="datetimerange"
                          range-separator="To"
                          start-placeholder="Start date"
                          end-placeholder="End date"
                        ></el-date-picker>
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('daterange')"
                        >
                          The date field is required
                        </span>
                      </div>
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Venue</div>
                      <div>
                        <ul class="demo-alignment">
                          <li>
                            <vs-radio
                              vs-name="radios-ticket-mode"
                              vs-value="offline"
                              v-model="event.mode"
                            >
                              Offline/Hybrid
                            </vs-radio>
                          </li>
                          <li>
                            <vs-radio
                              vs-name="radios-ticket-mode"
                              vs-value="onsite"
                              v-model="event.mode"
                            >
                              Online
                            </vs-radio>
                          </li>
                          <li>
                            <vs-radio
                              vs-name="radios-ticket-mode"
                              vs-value="onsite"
                              v-model="event.mode"
                            >
                              To be announced
                            </vs-radio>
                          </li>
                        </ul>
                      </div>
                      <vs-input
                        v-validate="'required'"
                        name="venue"
                        placeholder="Singapore EXPO, Atrium 4"
                        class="w-full"
                        v-model="event.venue"
                        onkeypress="return /^[\w-_. ]*$/i.test(event.key)"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('venue')"
                      >
                        {{ splitError(errors.first("venue"), " venue") }}
                      </span>
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Event Type</div>
                      <div>
                        <ul class="demo-alignment">
                          <li>
                            <vs-radio
                              v-model="event.freeevent"
                              vs-name="radios-freeevent"
                              :vs-value="1"
                            >
                              Free Event
                            </vs-radio>
                          </li>
                          <li>
                            <vs-radio
                              v-model="event.freeevent"
                              vs-name="radios-freeevent"
                              :vs-value="0"
                            >
                              Paid Event
                            </vs-radio>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="d-flex justify-between">
                      <vs-button
                        to="/onboarding/create-seller"
                        small
                        color="grey"
                        class="mt-6 mr-auto"
                        >Back</vs-button
                      >
                      <vs-button small class="mt-6 ml-auto">Submit</vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <!-- <div>Mode : {{ mode }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
//import Service from "../../services";
import LogoRed from "../../../layouts/components/LogoRed.vue";
import FBBtn from "../../../layouts/components/FBBtn.vue";
import GoogleBtn from "../../../layouts/components/GoogleBtn.vue";
import moment from "moment";

export default {
  components: { LogoRed, FBBtn, GoogleBtn },
  data() {
    return {
      monthlist: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      form: {
        logo: "",
        name: "",
        domain: "",
        folder: "",
        timezone: "Asia/Bangkok",
        emailfromname: "",
        emailfromemail: "",
        smssender: "",
        fbpage: "",
        lineid: "",
        txtcolor: "",
        bgcolor: "",
        bgimg: "",
        font: "",
        bank1: "",
        bankaccname1: "",
        bankaccno1: "",
        bank2: "",
        bankaccname2: "",
        bankaccno2: "",
        gtmid: "",
        gaid: "",
        fbpid: "",
        awcid: "",
        awclabel: "",
        phone: "",
        email: "",
        contactperson: "",
      },
      event: {
        s: null,
        name: "",
        slug: "",
        daterange: [
          moment().format("YYYY-MM-DD HH:mm"),
          moment().format("YYYY-MM-DD HH:mm"),
        ],
        selldaterange: [
          moment().format("YYYY-MM-DD HH:mm"),
          moment().format("YYYY-MM-DD HH:mm"),
        ],
        shortdesc: "",
        timezone: "Asia/Bangkok",
        venue: "",
        poster: "",
        zoom_status: 1,
        zoom_account_no: "acc_2",
        session_type: "webinar",
        mode: "online",
        engine: "zoom",
        freeevent: 0,
        privacy: "public",
        private_token: "",
      },
      popupActivo: false,
      checkbox_remember_me: false,
      mode: "Development",
      suckerArea: [],
      suckerCanvas: null,
      posterData: {
        type: "poster",
      },
      bgImgData: {
        type: "bgimg",
      },
      fontList: [],
      logo: "",
      bankList: [
        {
          name: "Kasikorn Bank",
          code: "kbank",
        },
        {
          name: "Siam Commercial Bank",
          code: "scb",
        },
        {
          name: "Krungthai Bank",
          code: "ktb",
        },
        {
          name: "Bank of Ayudhya",
          code: "bay",
        },
        {
          name: "Bangkok Bank",
          code: "bbl",
        },
      ],
      role: "user",
      acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      logoUpdate: null,
      bgUpdate: null,
      imageHeight: 0,
      imageWidth: 0,
      popupActivo2: false,
    };
  },
  props: ["merchant_id"],
  watch: {
    "event.name": function (newVal, oldVal) {
      var slugify = require("slugify");
      this.event.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove:
          /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false, // strip special characters except replacement, defaults to `false`
      });

      if (this.event.slug.match(/(\w+)/g).length > 5) {
        var words = this.event.slug.split("-");
        this.event.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    "event.mode": function (newVal, oldVal) {
      if (newVal == "online") {
        this.event.zoom_status = 1;
        this.disableZoomToggle = false;
      } else {
        this.event.zoom_status = 0;
        this.disableZoomToggle = true;
      }
    },
    // "event.freeevent": function (newVal, oldVal) {
    //   if (newVal == 1) {
    //     this.ticketForm.price = 0;
    //     this.ticketForm.fullprice = 0;
    //     this.currencyForm.currency = null;
    //     this.currencyForm.altcurrencycode = null;
    //     this.currencyForm.altcurrencyrate = null;
    //   }
    // },
  },
  computed: {
    dateTextOnCard() {
      // const
      const startmoment = moment(this.event.daterange[0]);
      const tomoment = moment(this.event.daterange[1]);
      const startdayofweekname = startmoment.format("dddd");
      const startmonthtext = startmoment.format("MMMM");
      const tomonthtext = tomoment.format("MMMM");
      const startyeartext = startmoment.format("YYYY");
      const toyeartext = startmoment.format("YYYY");
      let dateText = "";

      if (startmoment.isSame(tomoment)) {
        //Same day - Monday, 1 August 2022
        dateText = `${startdayofweekname}, ${startmoment.date()} ${startmonthtext} ${startyeartext}`;
      } else if (startmonthtext == tomonthtext && startyeartext == toyeartext) {
        //Same calendar month - 1 - 2 August 2022
        dateText = `${startmoment.date()} - ${tomoment.date()} ${startmonthtext} ${startmoment.format(
          "YYYY"
        )}`;
      } else if (startyeartext == toyeartext) {
        // Same calendar year - 1 August - 30 September 2022
        dateText = `${startmoment.date()} ${startmonthtext} - ${tomoment.date()} ${tomonthtext} ${startmoment.format(
          "YYYY"
        )}`;
      } else {
        // General case (spans calendar years) - 1 August 2022 - 31 March 2023
        dateText = `${startmoment.date()} ${startmonthtext} ${startmoment.format(
          "YYYY"
        )} - ${tomoment.day()} ${tomonthtext} ${tomoment.format("YYYY")}`;
      }
      return dateText;
    },
  },
  created() {
    if (process.env.VUE_APP_ENV != "development") {
      this.mode = "Production";
    }
  },
  mounted() {
    if (localStorage.getItem("onboarding-form")) {
      this.form = JSON.parse(localStorage.getItem("onboarding-form"));
    } else {
      this.$router.push("/onboarding/create-seller");
    }
    // console.log(this.form);
    this.setImageSize();
  },
  methods: {
    login() {
      //console.log("login");
      let data = {
        email: this.email,
        password: this.password,
        redirect: getParamFromLink("redirectURL") ? true : null,
      };

      this.$vs.loading();

      this.$store
        .dispatch("Auth/login", data)
        .then((loginRes) => {
          if (data.redirect) {
            // redirect to check-in page
            window.location.href = `https://ascriptlab.com/soldd-out?token=${loginRes.data.redirect_token}`;
          }
          this.$store.dispatch("Auth/setUser").then((res) => {
            let s = res.default.s;
            let e = res.default.e;
            let name = res.info.name;

            if (s == null || e == null) {
              this.$router.push("/profile/selectAssets");
              this.$vs.loading.close();
              return;
            }

            this.$store.dispatch("Utility/setMerchant", s).then((res) => {
              this.$store.dispatch("Utility/setEvent", e).then((res) => {
                this.$store.dispatch("updateUserInfo", { displayName: name });
                this.$store.dispatch("Event/setMyEvents").then((event) => {
                  setTimeout(() => {
                    this.$vs.loading.close();
                    this.$router.push("/dash");
                  }, 1000);
                });
                return;
              });
            });

            return;
          });
        })
        .catch((err) => {
          this.$vs.loading.close();

          this.$vs.notify({
            title: "Oops!",
            text: "Email or Password not correct.",
            color: "danger",
          });
        });
      /*
      Service.Auth.login(data).then(res => {
        console.log(res.data);
        if (res.data.success) {
          this.$store.dispatch("Auth/setUser");
        }
      });
      */
    },
    setImageSize() {
      let posterimage = document.querySelector("img");
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    removeposter() {
      this.event.poster = null;
    },
    chooseImage() {
      document.getElementById("file-upload-img").click();
    },
    onUploadImages() {
      // this.posterUpdate = this.$refs.fileImage.files[0]
      this.event.poster = this.$refs.fileImage.files[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.event.poster = reader.result;
        // this.posterUpdate = reader.result
        this.setImageSize();
      };
      reader.readAsDataURL(this.$refs.fileImage.files[0]);
      this.$refs.fileImage.value = null;
    },
    splitError(val, word) {
      if (!val) {
        return;
      } else {
        const data = val.split(word);
        return data[0] + data[1];
      }
    },
  },
};

function getParamFromLink(data) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(data);
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
#card-bg {
  position: absolute;
  left: 0%;
  top: 30px;
  background: linear-gradient(180deg, #013562 0%, #000 30%);
  min-height: 800px;
}
#logo-badge {
  position: absolute;
  left: 15px;
  top: 0;
  width: 70px;
  height: 40px;
  background: #fff;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  z-index: 2;
}
</style>
